export default "Partial Common Ownership has <b>reduced investment efficiency</b>.\n";